export const Routes = {
  home: "/",
  aboutUs: "/about-us",
  contactUs: "/contact-us",
};
